/* global window */
import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import ChatViewerWrapper from './components/ChatViewerWrapper/ChatViewerWrapper';
import ChatMobileWrapper from './components/ChatMobileWrapper/ChatMobileWrapper';
import {ExperimentsProvider} from 'wix-experiments-react';
import {wixAxiosConfig} from 'wix-axios-config';
import axios from 'axios';
import configureStore from './store/configureStore';

const store = configureStore();

const rootEl = document.getElementById('root');
const experiments = window.__EXPERIMENTS__;
const isMobile = window.Wix.Utils.getDeviceType() === 'mobile';

if (!window.location.origin) {
  window.location.origin = `${window.location.protocol}//${window.location.hostname}${(window.location.port ? (`:${window.location.port}`) : '')}`;
}

wixAxiosConfig(axios, {
  baseURL: '/'
});

render(
  <Provider store={store}>
    <ExperimentsProvider options={{experiments}}>
      {isMobile ? <ChatMobileWrapper/> : <ChatViewerWrapper/>}
    </ExperimentsProvider>
  </Provider>,
  rootEl
);



// WEBPACK FOOTER //
// ./chat-app/index.js